export { default } from './ConnectButton';
